
import http from "../http";

const apiEndpoint = process.env.REACT_APP_BASE_URL +  "/api/Auth/ChangePassword";

export function PostChangePassword(obj) {
  return http.post(apiEndpoint, obj);
}
